import { useRef, useState } from "react";
import Card from "../Card/Card";
import './progress.css';
import { motion } from "framer-motion";
import { Copy } from 'lucide-react';
const ProgressBar = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="carve-tube-container carve-space-top-hefty carve-space-bottom-hefty">
        <div className="carve-tube">
          <div className="carve-liquid"></div>
          <div className="carve-overlay"></div>
        </div>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <pre>
            <code>
              <>
                <span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-tube-container</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-tube</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-liquid</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;&nbsp;<span className='cn'>&lt;div</span>
                <span className='cln'> class="</span>
                <span className='cn'>carve-overlay</span>
                <span className='cln'>"</span>
                <span className='cn'>&gt;&lt;/div&gt;</span>
              </>
              <br />
              <>
                &nbsp;<span className='cn'>&lt;/div&gt;</span>
              </>
              <br />
              <>
                <span className='cn'>&lt;/div&gt;</span>
              </>
            </code>

          </pre>
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>

      </div>
    </motion.div>
  );
}

const progressBarCard = () => {
  return (
    <Card
      CardTitle="Progress Bar"
      CardBody={<ProgressBar />}
    />
  );
}
export default progressBarCard;